import { render, staticRenderFns } from "./DoctorSalary.vue?vue&type=template&id=a0cf87c0&"
import script from "./DoctorSalary.vue?vue&type=script&lang=js&"
export * from "./DoctorSalary.vue?vue&type=script&lang=js&"
import style0 from "./DoctorSalary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports